import React from 'react';
import { createRoot } from 'react-dom/client';
import { Dialog, DialogFooter } from '@fluentui/react/lib/Dialog';
import { FluentButton } from 'owa-fluent-v9-shims';

export default function showWebapplinkTestDialog(): void {
    let container = document.getElementById('webapplinkTestDialogContainer');
    if (!container) {
        container = document.createElement('div');
        container.id = 'webapplinkTestDialogContainer';
        window.document.body.appendChild(container);
    }
    const root = createRoot(container);

    root.render(<WebapplinkTestDialog root={root} container={container} />);
}

export interface WebapplinkTestDialogProps {
    root: ReturnType<typeof createRoot>;
    container: HTMLElement;
}
function WebapplinkTestDialog({ root, container }: WebapplinkTestDialogProps) {
    const [showDialog, setShowDialog] = React.useState(true);

    const dismissDialog = React.useCallback(() => {
        setShowDialog(false);
    }, []);

    React.useEffect(() => {
        if (!showDialog) {
            root.unmount();
            container.remove();
        }
    }, [showDialog, root, container]);

    return (
        <Dialog isClickableOutsideFocusTrap={true} hidden={!showDialog} minWidth={'350px'}>
            <span>{"You've successfully launched the WebAppLink Test Page!"}</span>
            <DialogFooter>
                <FluentButton appearance="primary" onClick={dismissDialog} text={'OK'} />
            </DialogFooter>
        </Dialog>
    );
}
